import client from "../client/client";

class LinkReqToDelivService {
  getAllUserCompanies({ direction, limit = 50, page = 0, sort }, value, cancelToken) {
    return client.post("/spp/companies", {
      payload: value,
      params: { page, limit, sort, direction },
      config: { cancelToken },
    });
  }
  getProjects({ direction, limit = 50, page = 0, sort }, value, cancelToken) {
    return client.post("/spp/projects", {
      payload: value,
      params: { page, limit, sort, direction },
      config: { cancelToken },
    });
  }
  getDeliverables({ projectId }, { page = 0, limit = 50, filter }, cancelToken) {
    return client.get(`/spp/projects/${projectId}/coverage-document`, {
      params: { page, limit, filter },
      config: { cancelToken },
    });
  }

  getRequirementsForDeliverables({ projectId, deliverableId }, { page = 0, limit = 50, isCovered }, cancelToken) {
    return client.get(`/spp/projects/${projectId}/coverage-document/${deliverableId}/coverage`, {
      params: { page, limit, isCovered },
      config: { cancelToken },
    });
  }
  getRequirementsForDeliverablesCount({ projectId, deliverableId }, cancelToken) {
    return client.get(`/spp/projects/${projectId}/coverage-document/${deliverableId}/coverage/count`, {
      config: { cancelToken },
    });
  }
  updateRequirementCoverage({ projectId, reqId, deliverableId }, { value }, cancelToken) {
    return client.post(`/spp/projects/${projectId}/requirements/${reqId}/coverage-document/${deliverableId}`, {
      payload: { value },
      config: { cancelToken },
    });
  }
}
export default new LinkReqToDelivService();
